/** Estado da agenda: uma consulta, sem escrita.
 *
 * A agenda é de leitura — marcar e remarcar acontece na ficha (SPEC-FE-007).
 * Aqui só se pergunta "o que está marcado neste período".
 */

import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { buscarAgenda, type Agenda } from "./api";
import { chaveDoDia, janelaDa, type Visao } from "./calendario";

export const CHAVE_DA_AGENDA = ["agenda"] as const;

/** O projetor é assíncrono e um colega pode marcar contato enquanto a tela
 * está aberta. Vinte segundos é o mesmo ritmo do funil — as duas telas mostram
 * o mesmo read model, e ritmos diferentes fariam uma parecer atrasada. */
const INTERVALO_DE_RELEITURA_MS = 20_000;

export function useAgenda(visao: Visao, referencia: Date): UseQueryResult<Agenda> {
  const { desde, ate } = janelaDa(visao, referencia);

  return useQuery({
    // A janela na chave, e não a data de referência: dois dias da mesma semana
    // pedem exatamente o mesmo período, e refazer a consulta ao trocar de dia
    // dentro da semana seria uma ida à rede para receber o mesmo.
    queryKey: [...CHAVE_DA_AGENDA, chaveDoDia(desde), chaveDoDia(ate)],
    queryFn: () => buscarAgenda(desde, ate),
    refetchInterval: INTERVALO_DE_RELEITURA_MS,
    staleTime: 5_000,
  });
}
